export default __webpack_public_path__ + "static/media/icon-voir.f11fb100.svg";